import axios from "axios";


export const Api = axios.create({
  baseURL: 'https://api-cohorts-manager.concredito.com.br',
  // baseURL: 'http://localhost:8007',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

Api.defaults.timeout = 60000

Api.interceptors.request.use((config) => {

  const storageDataString = localStorage.getItem('user');
  const userStorage = storageDataString ? JSON.parse(storageDataString) : null;

  if (userStorage && userStorage.authToken) {
    config.headers.Authorization = `Bearer ${userStorage.authToken}`;
  }
  return config;
});